import { Fragment } from "react"
import { SEARCH_HIT_CLASS, splitHighlighted } from "@/lib/search-highlight"
import { cn } from "@/lib/utils"

type HighlightedTextProps = {
  text: string
  words: readonly string[]
  markClassName?: string
}

export function HighlightedText({ text, words, markClassName }: HighlightedTextProps) {
  if (words.length === 0) return <>{text}</>

  return (
    <>
      {splitHighlighted(text, words).map((part, index) =>
        part.hit ? (
          <mark key={index} className={cn(SEARCH_HIT_CLASS, markClassName)}>
            {part.text}
          </mark>
        ) : (
          <Fragment key={index}>{part.text}</Fragment>
        ),
      )}
    </>
  )
}
